import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  saveBulletinCoverImageSuccess,
  saveBulletinCoverImageFailure,
  updateBulletinCoverImageSuccess,
  updateBulletinCoverImageFailure,
  deleteBulletinCoverImageSuccess,
  deleteBulletinCoverImageFailure,
} from "./bulletinCoverImageActions";
import {
  saveBulletinCoverImage,
  updateBulletinCoverImage,
  deleteBulletinCoverImageApi
} from "./bulletinCoverImage";

// 🔹 Save Cover Image
function* saveBulletinCoverImageSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveBulletinCoverImage, apiPayloadRequest);

    if (data?.type === 1) {
      const result = { ...apiPayloadRequest, ...data.data };
      yield put(saveBulletinCoverImageSuccess(result));
      if (action.callback) action.callback({ type: 1, data: result });
    } else {
      yield put(saveBulletinCoverImageFailure(data?.error || "Save failed"));
      if (action.callback) action.callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(saveBulletinCoverImageFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// 🔹 Update Cover Image
function* updateBulletinCoverImageSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(updateBulletinCoverImage, apiPayloadRequest);

    if (data?.type === 1) {
      const result = { ...apiPayloadRequest, ...data.data };
      yield put(updateBulletinCoverImageSuccess(result));
      if (action.callback) action.callback({ type: 1, data: result });
    } else {
      yield put(updateBulletinCoverImageFailure(data?.error || "Update failed"));
      if (action.callback) action.callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(updateBulletinCoverImageFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}
function* deleteBulletinCoverImageSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload || {};

    const data = yield call(deleteBulletinCoverImageApi, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(deleteBulletinCoverImageSuccess(apiPayloadRequest));
      if (callback) callback({ type: 1, data });
    } else {
      yield put(deleteBulletinCoverImageFailure(data?.error || "Delete failed"));
      if (callback) callback({ type: 0, error: data?.error });
    }
  } catch (error) {
        yield put(deleteBulletinCoverImageFailure(error.message));
    if (action.payload?.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}
export default function* bulletinCoverImageWatcherSaga() {
  yield takeLatest(
    actionTypes.SAVE_BULLETIN_COVERIMAGE_REQUEST,
    saveBulletinCoverImageSaga
  );
  yield takeLatest(
    actionTypes.UPDATE_BULLETIN_COVERIMAGE_REQUEST,
    updateBulletinCoverImageSaga
  );
  yield takeLatest(
    actionTypes.DELETE_BULLETIN_COVERIMAGE_REQUEST,
    deleteBulletinCoverImageSaga
  );
}
